module.exports = __webpack_public_path__ + "img/hardware_store.89ee3d37.png";